import React, { FC } from 'react';
import { Button } from 'antd';

import s from './FormFooterTabs.module.scss';
interface IFormFooterTabs {
  handleSaveTabData: () => void;
  handleResetTabData: () => void;
  disabledSave: boolean;
}
export const FormFooterTabs: FC<IFormFooterTabs> = ({
  handleSaveTabData,
  handleResetTabData,
  disabledSave,
}) => {
  return (
    <div className={s.FormFooterTabs}>
      <div className={s.btnsWrapper}>
        <Button type={'primary'} onClick={handleSaveTabData} disabled={disabledSave}>
          Сохранить
        </Button>
        <Button type={'default'} onClick={handleResetTabData}>
          Отменить
        </Button>
      </div>
    </div>
  );
};
